import React, { useCallback, useEffect, useState } from 'react'
import {
  CAccordion,
  CAccordionBody,
  CAccordionHeader,
  CAccordionItem,
  CRow,
} from '@coreui/react-pro'
import AddForm from './AddForm'
import SponsorService from 'src/service/SponsorService'
import AdminSponsorTable from './AdminSponsorTable'

const AdminSponsorDirectory = () => {
  const [users, setUsers] = useState([])
  const [activePage, setActivePage] = useState(1)
  const [itemsPerPage, setItemsPerPage] = useState(10)
  const [columnFilter, setColumnFilter] = useState({})
  const [columnSorter, setColumnSorter] = useState({})

  const fetchUsers = useCallback(async () => {
    const offset = itemsPerPage * activePage - itemsPerPage
    let params = new URLSearchParams()
    params.append('sponsor_scope', 'hub')
    Object.keys(columnFilter).forEach((key) => {
      params.append(key, columnFilter[key])
    })
    columnSorter &&
      columnSorter.column !== undefined &&
      params.append('sort', `${columnSorter.column}%${columnSorter.state}`)

    try {
      const result = await SponsorService.getSponsor(offset, itemsPerPage, activePage, params)
      setUsers(result.data)
    } catch (error) {
      console.error('Error fetching sponsors:', error)
    }
  }, [activePage, itemsPerPage, columnFilter, columnSorter])

  useEffect(() => {
    fetchUsers()
  }, [fetchUsers])

  return (
    <CRow>
      <CAccordion activeItemKey={1} alwaysOpen>
        <CAccordionItem itemKey={1}>
          <CAccordionHeader>
            <strong>Create Sponsor</strong>
          </CAccordionHeader>
          <CAccordionBody>
            <AddForm fetchUsers={fetchUsers} />
          </CAccordionBody>
        </CAccordionItem>
      </CAccordion>
      <CAccordion activeItemKey={1}>
        <CAccordionItem itemKey={1}>
          <CAccordionHeader>
            <strong>Sponsor Directory</strong>
          </CAccordionHeader>
          <CAccordionBody>
            <AdminSponsorTable
              users={users}
              setUsers={setUsers}
              fetchUsers={fetchUsers}
              setActivePage={setActivePage}
              setItemsPerPage={setItemsPerPage}
              setColumnFilter={setColumnFilter}
              setColumnSorter={setColumnSorter}
              itemsPerPage={itemsPerPage}
              activePage={activePage}
              columnFilter={columnFilter}
              columnSorter={columnSorter}
            />
          </CAccordionBody>
        </CAccordionItem>
      </CAccordion>
    </CRow>
  )
}

export default AdminSponsorDirectory
